<template>
  <div class="wrap">
    <div @click="popupVisible=true">
      <mt-cell title="支付方式" :value="value" is-link></mt-cell>
    </div>
    <mt-popup v-model="popupVisible" popup-transition="popup-fade" position="bottom" class="popup">
      <div class="picker">
        <div class="header">
          <span class="btc-close" @click="popupVisible=false">确定</span>
        </div>
        <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import { Cell, Popup, Picker } from 'mint-ui'
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  components: {
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  data() {
    return {
      popupVisible: false,
      slots: [
        {
          defaultIndex: 0,
          values: ['HammerPlus'],
          textAlign: 'center',
          className: 'slot-shim',
        },
      ],
    }
  },
  methods: {
    onValuesChange(picker, values) {
      this.$emit('input', values[0])
    },
  },
}
</script>
<style>
.slot-shim {
  width: 100%;
}
</style>
<style scoped>
.mint-cell {
  border-radius: 6px;
}
.wrap {
  background-color: white;
  border-radius: 6px;
}
.popup {
  width: 100%;
}
.picker {
  overflow: hidden;
}
.header {
  height: 36px;
  text-align: right;
  line-height: 36px;
  padding: 0 10px;
  border-bottom: 1px solid #eee;
}
</style>